module.exports = __webpack_public_path__ + "img/elcart.8d92a5b3.svg";